import Swiper, {Autoplay, EffectFade, FreeMode, Navigation, Pagination} from "swiper";

export function initCarousels() {
	startCarousels();
}

function startCarousels() {
	//various carousel triggers
	let logoGalleries = document.querySelectorAll('.logo-gallery');
	if (logoGalleries.length > 0) {
		logoGalleries.forEach((section) => {
			const carousel = section.querySelector(
				'.logo-gallery__carousel',
			) as HTMLElement;
			new Swiper(carousel, {
				modules: [Autoplay, FreeMode],
				slidesPerView: "auto",
				grabCursor: true,
				spaceBetween: 16,
				speed: 11000,
				loop: true,
				autoplay: {
					delay: 0.5,
					disableOnInteraction: false,
				},
				freeMode: true,
				centerInsufficientSlides: true,
				breakpoints: {
					768: {
						spaceBetween: 32,
					},
				},
			})
		});
	}

	let $profiles = $('.profiles');
	if ($profiles.length > 0) {
		$profiles.each((_index, element) => {
			$(element).addClass(`profiles-${_index}`);
			$(element)
				.find('.swiper-button--next')
				.addClass(`swiper-button--next-profile-${_index}`);
			$(element)
				.find('.swiper-button--prev')
				.addClass(`swiper-button--prev-profile-${_index}`);
			new Swiper(`.profiles-${_index}`, {
				modules: [Navigation],
				slidesPerView: 1.15,
				spaceBetween: 24,
				navigation: {
					disabledClass: 'disabled',
					nextEl: `.swiper-button--next-profile-${_index}`,
					prevEl: `.swiper-button--prev-profile-${_index}`,
				},
				breakpoints: {
					576: {
						slidesPerView: 2,
					},
					992: {
						slidesPerView: 3,
					},
				},
			});
		});
	}

	let testimonials = document.querySelectorAll('.testimonials');
	if (testimonials.length > 0) {
		testimonials.forEach((section, index) => {
			$(section).addClass('testimonials-' + index);

			const carousel = section.querySelector(
				'.testimonials__carousel',
			) as HTMLElement;

			new Swiper(carousel, {
				modules: [Navigation, Pagination, EffectFade],
				spaceBetween: 30,
				effect: 'fade',
				fadeEffect: { crossFade: true },
				pagination: {
					el: '.testimonials-' + index + ' .swiper-pagination',
					type: 'fraction',
				},
				navigation: {
					disabledClass: 'disabled',
					nextEl: '.testimonials-' + index + ' .swiper-button--next',
					prevEl: '.testimonials-' + index + ' .swiper-button--prev',
				},
			});
		});
	}

	let experiences = document.querySelectorAll('.experiences');
	if (experiences.length > 0) {
		experiences.forEach((section, index) => {
			$(section).addClass('experiences-' + index);
			const carousel = section.querySelector(
				'.experiences__carousel',
			) as HTMLElement;
			new Swiper(carousel, {
				modules: [Navigation, Pagination, EffectFade],
				spaceBetween: 30,
				effect: 'fade',
				fadeEffect: { crossFade: true },
				navigation: {
					disabledClass: 'disabled',
					nextEl: '.experiences-' + index + ' .swiper-button--next',
					prevEl: '.experiences-' + index + ' .swiper-button--prev',
				},
			});
		});
	}
}



// WEBPACK FOOTER //
// ./scripts/components/carousels.ts